export default class ProjectNotCreatedError extends Error {
  constructor(projectName) {
    super('Project not created: ' + projectName); // (1)
    this.name = 'ProjectNotCreatedError'; // (2)
    this.projectName = projectName;
  }
}
